import { render, staticRenderFns } from "./AirList.vue?vue&type=template&id=2807585e&scoped=true"
import script from "./AirList.vue?vue&type=script&lang=js"
export * from "./AirList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2807585e",
  null
  
)

export default component.exports